import { EventBus } from '@/utils/event-bus';
import i18n from '@/locales';
import HTTP from '@/utils/http';
import pageableFactory from '@/store/modules/mixins/pageable';
import crudableFactory from '@/store/modules/mixins/crudable';

const pageable = pageableFactory();
const crudable = crudableFactory();
const defaultState = () => ({
  ...pageable.state,
  ...crudable.state,
  item: {},
});

const emailsModule = {
  base: 'emails',
  namespaced: true,
  state: defaultState(),
  mutations: {
    ...pageable.mutations,
    ...crudable.mutations,
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET(state, { updated }) {
      state.item = updated;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    PAGINATE: pageable.actions.paginatePartialApplication({
      url: 'emails',
    }),
    GET: crudable.actions.getPartialApplication({ uriRoot: 'emails' }),
    UPDATE: crudable.actions.updatePartialApplication({ uriRoot: 'emails', name: 'email template' }),
    RESET({ commit, state }, email) {
      return HTTP({
        method: 'put',
        url: `emails/${email.id}/reset`,
      }).then((response) => {
        commit('SET', { updated: response.data.data });
        EventBus.$emit('renderGlobalMessage', ({ message: i18n.t('branding.emailTemplate.resetMessage', { name: state.item.identifier }), icon: 'check', type: 'success' }));
      });
    },
  },
  getters: {
    ...pageable.getters,
    viewingEmail: state => state.item,
  },
};

export default emailsModule;
